import { createResourceRegistry } from './resource-registry.js';

/**
 * Library information of a loaded library in the current application
 * @public
 */
export interface LibraryInfo {
	/**
	 * Name of the library (name in package.json)
	 * @public
	 */
	name: string;
	/**
	 * Version of the library (version in package.json)
	 * @public
	 */
	version: string;
}

/**
 * @internal
 */
export const registry = createResourceRegistry<LibraryInfo>(true);
/**
 * Register a library into the global record.
 * @public
 * @param library - Library information
 */
export function registerLibrary(library: LibraryInfo): void {
	registry.add(library);
}

/**
 * Retrieves all the registered libraries.
 * @public
 * @returns Map with all registered libraries
 */
export function getLibraries(): LibraryInfo[] {
	return registry.list();
}

/**
 * Retrieves a single registered library based on the name of it.
 * @public
 * @param name - Name of the library
 * @returns Registered library or undefined if the library is not registered
 */
export function getLibrary(name: string): LibraryInfo | undefined {
	return registry.get(name);
}

/**
 * Removes a library from the registry
 * @internal
 * @remarks Should not be exported to the public
 * @param name - Name of the library to remove
 */
export function removeLibrary(name: string): void {
	registry.remove(name);
}
